module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  这是购物车页面。\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-57de212c!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/cart.vue
// module id = 51
// module chunks = 1